import { Paragraph } from '../../typography/Paragraph/Paragraph';
import styles from './InputDetail.module.css';

interface Props {
  testid?: string;
  errorMessage?: string | string[];
  helpText?: string;
  showCharacterCount?: boolean;
  charCount?: number;
  maxLength?: number;
}

export function InputDetail(props: Props) {
  const {
    testid,
    errorMessage,
    helpText,
    showCharacterCount,
    charCount,
    maxLength,
  } = props;
  return errorMessage?.length || helpText?.length || showCharacterCount ? (
    <div className={styles.info}>
      {errorMessage && (
        <Paragraph
          testid={`${testid}-error-message`}
          className={styles.error}
          variant="caption"
        >
          {Array.isArray(errorMessage) ? errorMessage[0] : errorMessage}
        </Paragraph>
      )}
      {helpText && !errorMessage && (
        <Paragraph className={styles.help} variant="caption">
          {helpText}
        </Paragraph>
      )}
      {maxLength && showCharacterCount && (
        <Paragraph className={styles.count} variant="caption">
          {charCount}/{maxLength}
        </Paragraph>
      )}
    </div>
  ) : null;
}
